@if (isSaving) {
<i
  class="pi pi-spin pi-spinner flex align-center flex-center"
  style="color: var(--nt-blue); width: 1.5rem; height: auto; font-weight: bold; font-size: 1.1rem;"
></i>
} @else if (isSaved) {
<i
  class="pi pi-check-circle flex align-center flex-center"
  style="color: var(--nt-green); width: 1.5rem; height: auto; font-weight: bold; font-size: 1.1rem;"
></i>
} @else if (error) {
<i
  class="pi pi-times-circle flex align-center flex-center"
  style="color: var(--nt-yellow); width: 1.5rem; height: auto; font-weight: bold; font-size: 1.1rem;"
></i>
}
